import { useQuery } from "@tanstack/vue-query";
import { computed, MaybeRefOrGetter, toRef } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";
import { V4HSiteId } from "@/data/common/ids";

export function useGetSiteProgramsQuery(siteId: MaybeRefOrGetter<V4HSiteId>) {
  const v4b = useServices().v4b.clientSdk;
  const _siteId = toRef(siteId);

  return useQuery({
    queryKey: SitesQueryKeys.programs(_siteId),
    queryFn: async () => v4b.siteProgram.findAll(_siteId.value),
    enabled: computed(() => _siteId.value > 0),
  });
}
